// @ts-ignore
import configureStore from './configureStoreProxy';
const store = configureStore({});
export default store;
